import React from 'react';
import {t} from '@lingui/core/macro';

import {CreateEntityButton} from 'entities/tariff';

interface ICreatePortMonitorButtonProps {
    onClick: () => void,
    disabled?: boolean,
}

const CreatePortMonitorButton: React.FC<ICreatePortMonitorButtonProps> = ({onClick, disabled}) => (
    <CreateEntityButton ariaLabel={t`Добавить порт`} onClick={onClick} disabled={disabled}>
        {t`Добавить порт`}
    </CreateEntityButton>
);

export default CreatePortMonitorButton;
